import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      routing: {
        routes: {
          quickOrder: { paths: ['my-account'] },
          myAccount: {
            paths: ['my-account'],
          },
        },
      },
    }),
  ],
})
export class MyAccountRoutesModule {}
